import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Link } from "react-router-dom";

export default function ModalInit({ url, linkToo, imgLink }) {
  const [show, setShow] = useState(true);
  const handleClose = () => setShow(false);

  return (
    <>
      <Modal
        size="lg"
        show={show}
        onHide={handleClose}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
        <div style={{ textAlign: 'center' }}>
          {(url === "") & (linkToo === "") ? (
            
            <img className="img-fluid" src={imgLink} alt="Imagen del popup" style={{ width: '75%', margin: '0 auto' }}/>
            
          ) : (url === "") & (linkToo !== "") ? (
            <Link to={linkToo}>
              <img className="img-fluid" src={imgLink} alt="Imagen del popup" style={{ width: '100%' }}/>
            </Link>
          ) : (
            <a href={url} target="_blank" rel="noreferrer">
              <img className="img-fluid" src={imgLink} alt="Imagen del popup" style={{ width: '100%' }}/>
            </a>
          )}
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
